/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteBlob.defs.js";
export { main as default } from "./deleteBlob.defs.js";
